module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "box-card",
    attrs: {
      "shadow": "hover"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "el-row el-align-middle el-justify-space-between clearfix"
        }, [_c('span', {
          staticClass: "card-head"
        }, [_vm._v("Voice Insights")]), _vm._v(" "), _c('el-button', {
          staticClass: "pull-right",
          attrs: {
            "size": "small",
            "type": "text",
            "icon": "el-icon-refresh",
            "disabled": _vm.loadingTranscripts,
            "loading": _vm.loadingTranscripts
          },
          on: {
            "click": _vm.onRefreshTranscripts
          }
        }, [_vm._v("\n        Refresh\n      ")])], 1)]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingTranscripts),
      expression: "loadingTranscripts"
    }],
    ref: "voiceTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.paginatedTranscripts,
      "element-loading-text": "Loading...",
      "row-key": "id"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50",
      "reserve-selection": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "score",
      "label": "Score",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-rate', {
          attrs: {
            "disabled": "",
            "colors": ['#99A9BF', '#F7BA2A', '#FF9900'],
            "text-color": "#ff9900",
            "size": 12
          },
          model: {
            value: (row.score),
            callback: function($$v) {
              _vm.$set(row, "score", $$v)
            },
            expression: "row.score"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sender",
      "label": "Sender",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', {
          staticClass: "sender-name"
        }, [_c('i', {
          staticClass: "el-icon-user"
        }), _vm._v(" " + _vm._s(row.sender) + " ")]), _vm._v(" "), (row.location) ? _c('span', {
          staticClass: "sender-info"
        }, [_c('i', {
          staticClass: "el-icon-location"
        }), _vm._v(" " + _vm._s(row.location) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('span', {
          staticClass: "sender-info"
        }, [_c('i', {
          staticClass: "el-icon-time"
        }), _vm._v(" " + _vm._s(_vm.formatDate(row.timestamp)) + "\n        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "summary",
      "label": "Summary",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', {
          staticClass: "summary"
        }, [_vm._v("\"" + _vm._s(_vm.previewSummary(row.transcript)) + "\"")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tags",
      "label": "Tags",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', {
          staticClass: "tags-cell"
        }, _vm._l((row.tags), function(tag) {
          return _c('el-tag', {
            key: tag,
            attrs: {
              "size": "mini"
            }
          }, [_vm._v("\n            " + _vm._s(tag) + "\n          ")])
        }), 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tone",
      "label": "Tone",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.tone) ? _c('el-tag', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("\n          " + _vm._s(_vm.capitalize(row.tone)) + "\n        ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Actions",
      "width": "180",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button-group', {
          staticClass: "action-group"
        }, [_c('el-tooltip', {
          attrs: {
            "content": "Preview Audio",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "size": "mini",
            "icon": "fa fa-eye"
          },
          on: {
            "click": function($event) {
              return _vm.onPreviewAudio(row)
            }
          }
        })], 1), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": row.approved ? 'Approved for On-Air' : 'Approve for On-Air',
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "size": "mini",
            "icon": row.approved ? 'fa fa-podcast' : 'el-icon-success'
          },
          on: {
            "click": function($event) {
              return _vm.onApprove(row)
            }
          }
        })], 1), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": row.flagged ? 'Unflag' : 'Flag for Review',
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "size": "mini",
            "icon": row.flagged ? 'fa fa-flag' : 'fa fa-flag-o'
          },
          on: {
            "click": function($event) {
              return _vm.onToggleFlag(row)
            }
          }
        })], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("\n      Showing page " + _vm._s(this.currentPage) + " to " + _vm._s(this.totalViews) + " of " + _vm._s(_vm.totalTranscripts) + " voice\n      notes\n    ")]), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "pager-count": _vm.pageCount,
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "total": _vm.totalTranscripts
    },
    on: {
      "current-change": _vm.onPageChange
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c8cc3074","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/analytics/voiceIntelligence/VoiceNotesTable.vue
// module id = 3391
// module chunks = 3